import axios from "axios";

const HTTP = axios.create({
  baseURL: process.env.REACT_APP_API_URL, withCredentials: true
});

const HTTPAuth = axios.create({
  baseURL: process.env.REACT_APP_API_URL, withCredentials: true
});

HTTP.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 404) {
      try {
        await refreshAccessToken();
        return HTTP(error.config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

/****************************************************/
//AuthContoller

export const getLoggedInUser = async () =>
  await HTTP.get("/auth/getme")

export const login = async (loginRequest) =>
  await HTTPAuth.post("/auth/login", loginRequest);

export const register = async (registerRequest) =>
  await HTTPAuth.post("/auth/register", registerRequest);

export const logout = async () =>
  await HTTP.post("/auth/logout")

export const refreshAccessToken = async () =>
  await HTTP.post("/auth/refresh")

export const forgotPassword = async (email) =>
  await HTTPAuth.post(`/email/forgot?email=${email}`)

export const resetPassword = async (token, newPassword) =>
  await HTTPAuth.post(`/email/reset?token=${token}&newPassword=${newPassword}`)


/*************************************************** */
//CarDetectionController

export const getMostRecentDetectedCar = async () =>
  await HTTP.get(`/car/getmostrecentcar`)


/*************************************************** */
//LightContoller

export const getTrafficLight = async () =>
  await HTTP.get(`/light/getlight/1`)
















/*************************************************** */
//ProductController

export const getAllProducts = async () =>
  await HTTP.get("/products/getproducts");

export const getModelProducts = async (modelName, sortBy) =>
  await HTTP.get(`/products/getproducts?modelName=${modelName}&sortBy=${sortBy}`)

export const getProductByModelCode = async (productModelCode) =>
  await HTTP.get(`/products/getproduct/${productModelCode}`)

export const getSearchProducts = async (searchTerm) =>
  await HTTP.get(`/products/search?searchTerm=${searchTerm}`);

export const logEntry = async (userId, productModelCode) =>
  await HTTP.post(`/products/createlog/${userId}/${productModelCode}`);

/******************************************************** */
//UserContoller

export const getOwnUserById = async (userId) =>
  await HTTP.get(`/users/getuser/${userId}`)

